import { render, staticRenderFns } from "./deepProNew.vue?vue&type=template&id=e24eb128&scoped=true&"
import script from "./deepProNew.vue?vue&type=script&lang=js&"
export * from "./deepProNew.vue?vue&type=script&lang=js&"
import style0 from "./deepProNew.vue?vue&type=style&index=0&id=e24eb128&scoped=true&lang=css&"
import style1 from "./deepProNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24eb128",
  null
  
)

export default component.exports